/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Public API
 * API that powers FreightSimple\'s SPA
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AddTrackingLineRequest,
  BookShipmentError,
  BookShipmentRequest,
  BookShipmentResponse,
  ChangePickupDatePreBookingRequest,
  CheckIfAddressIsResidentialRequest,
  CheckIfAddressIsResidentialResponse,
  CreateShipment2Request,
  DownloadThumbnailResponse,
  FlagShipmentRequest,
  GetChecklistResponse,
  GetCouponResponse,
  GetInvoicesZipRequest,
  GetOneShipmentResponse,
  GetShipmentsResponse,
  GetStartedSetStripePaymentMethodId,
  HasBookedOnlyOneShipmentResponse,
  HasPaymentMethodResponse,
  Invoice,
  ListDocumentsResponse,
  LocationContext,
  LookUpReferenceNumberResponse,
  LookupNmfcCodeForLineItemRequest,
  LookupNmfcCodeForLineItemResponse,
  LookupNmfcCodeNoDimensionsRequest,
  LookupNmfcCodeNoDimensionsResponse,
  MarkDeliveredRequest,
  MarkPickedUpRequest,
  PdfResponse,
  PollQuotesResponse,
  PreBookingShipment,
  RequestDeliveryHoursChangeRequest,
  RequestDeliveryHoursChangeResponse,
  RequestManualQuotesRequest,
  RequestPickupDateChangeRequest,
  SelectQuoteRequest,
  SetAddressAndContactRequest,
  SetAddressRequest,
  SetBrokerDetailsRequest,
  SetChecklistItemRequest,
  SetContactRequest,
  SetEmergencyDetailsRequest,
  SetProNumberRequest,
  SetReferenceAndNotesRequest,
  StarShipmentRequest,
  SwapTrackingIdForShipmentIdResponse,
  TrackingInfo,
  UnflagShipmentRequest,
  UnstarShipmentRequest,
  UploadShipmentDocumentRequest,
  ZipResponse,
} from '../models/index';
import {
    AddTrackingLineRequestFromJSON,
    AddTrackingLineRequestToJSON,
    BookShipmentErrorFromJSON,
    BookShipmentErrorToJSON,
    BookShipmentRequestFromJSON,
    BookShipmentRequestToJSON,
    BookShipmentResponseFromJSON,
    BookShipmentResponseToJSON,
    ChangePickupDatePreBookingRequestFromJSON,
    ChangePickupDatePreBookingRequestToJSON,
    CheckIfAddressIsResidentialRequestFromJSON,
    CheckIfAddressIsResidentialRequestToJSON,
    CheckIfAddressIsResidentialResponseFromJSON,
    CheckIfAddressIsResidentialResponseToJSON,
    CreateShipment2RequestFromJSON,
    CreateShipment2RequestToJSON,
    DownloadThumbnailResponseFromJSON,
    DownloadThumbnailResponseToJSON,
    FlagShipmentRequestFromJSON,
    FlagShipmentRequestToJSON,
    GetChecklistResponseFromJSON,
    GetChecklistResponseToJSON,
    GetCouponResponseFromJSON,
    GetCouponResponseToJSON,
    GetInvoicesZipRequestFromJSON,
    GetInvoicesZipRequestToJSON,
    GetOneShipmentResponseFromJSON,
    GetOneShipmentResponseToJSON,
    GetShipmentsResponseFromJSON,
    GetShipmentsResponseToJSON,
    GetStartedSetStripePaymentMethodIdFromJSON,
    GetStartedSetStripePaymentMethodIdToJSON,
    HasBookedOnlyOneShipmentResponseFromJSON,
    HasBookedOnlyOneShipmentResponseToJSON,
    HasPaymentMethodResponseFromJSON,
    HasPaymentMethodResponseToJSON,
    InvoiceFromJSON,
    InvoiceToJSON,
    ListDocumentsResponseFromJSON,
    ListDocumentsResponseToJSON,
    LocationContextFromJSON,
    LocationContextToJSON,
    LookUpReferenceNumberResponseFromJSON,
    LookUpReferenceNumberResponseToJSON,
    LookupNmfcCodeForLineItemRequestFromJSON,
    LookupNmfcCodeForLineItemRequestToJSON,
    LookupNmfcCodeForLineItemResponseFromJSON,
    LookupNmfcCodeForLineItemResponseToJSON,
    LookupNmfcCodeNoDimensionsRequestFromJSON,
    LookupNmfcCodeNoDimensionsRequestToJSON,
    LookupNmfcCodeNoDimensionsResponseFromJSON,
    LookupNmfcCodeNoDimensionsResponseToJSON,
    MarkDeliveredRequestFromJSON,
    MarkDeliveredRequestToJSON,
    MarkPickedUpRequestFromJSON,
    MarkPickedUpRequestToJSON,
    PdfResponseFromJSON,
    PdfResponseToJSON,
    PollQuotesResponseFromJSON,
    PollQuotesResponseToJSON,
    PreBookingShipmentFromJSON,
    PreBookingShipmentToJSON,
    RequestDeliveryHoursChangeRequestFromJSON,
    RequestDeliveryHoursChangeRequestToJSON,
    RequestDeliveryHoursChangeResponseFromJSON,
    RequestDeliveryHoursChangeResponseToJSON,
    RequestManualQuotesRequestFromJSON,
    RequestManualQuotesRequestToJSON,
    RequestPickupDateChangeRequestFromJSON,
    RequestPickupDateChangeRequestToJSON,
    SelectQuoteRequestFromJSON,
    SelectQuoteRequestToJSON,
    SetAddressAndContactRequestFromJSON,
    SetAddressAndContactRequestToJSON,
    SetAddressRequestFromJSON,
    SetAddressRequestToJSON,
    SetBrokerDetailsRequestFromJSON,
    SetBrokerDetailsRequestToJSON,
    SetChecklistItemRequestFromJSON,
    SetChecklistItemRequestToJSON,
    SetContactRequestFromJSON,
    SetContactRequestToJSON,
    SetEmergencyDetailsRequestFromJSON,
    SetEmergencyDetailsRequestToJSON,
    SetProNumberRequestFromJSON,
    SetProNumberRequestToJSON,
    SetReferenceAndNotesRequestFromJSON,
    SetReferenceAndNotesRequestToJSON,
    StarShipmentRequestFromJSON,
    StarShipmentRequestToJSON,
    SwapTrackingIdForShipmentIdResponseFromJSON,
    SwapTrackingIdForShipmentIdResponseToJSON,
    TrackingInfoFromJSON,
    TrackingInfoToJSON,
    UnflagShipmentRequestFromJSON,
    UnflagShipmentRequestToJSON,
    UnstarShipmentRequestFromJSON,
    UnstarShipmentRequestToJSON,
    UploadShipmentDocumentRequestFromJSON,
    UploadShipmentDocumentRequestToJSON,
    ZipResponseFromJSON,
    ZipResponseToJSON,
} from '../models/index';

export interface AddTrackingLineOperationRequest {
    addTrackingLineRequest?: AddTrackingLineRequest;
}

export interface BookShipmentOperationRequest {
    bookShipmentRequest?: BookShipmentRequest;
}

export interface ChangePickupDatePreBookingOperationRequest {
    changePickupDatePreBookingRequest?: ChangePickupDatePreBookingRequest;
}

export interface CheckIfAddressIsResidentialOperationRequest {
    checkIfAddressIsResidentialRequest?: CheckIfAddressIsResidentialRequest;
}

export interface Create2Request {
    createShipment2Request?: CreateShipment2Request;
}

export interface DeleteQuotedShipmentRequest {
    shipmentId: string;
    reason: string;
}

export interface DownloadThumbnailRequest {
    documentId: string;
}

export interface FlagShipmentOperationRequest {
    flagShipmentRequest?: FlagShipmentRequest;
}

export interface GetChecklistRequest {
    shipmentId: string;
}

export interface GetDocumentPdfRequest {
    documentId: string;
}

export interface GetInvoicePdfRequest {
    key: string;
    shipmentId: string;
}

export interface GetInvoicesZipOperationRequest {
    getInvoicesZipRequest?: GetInvoicesZipRequest;
}

export interface GetOneShipmentRequest {
    shipmentId: string;
}

export interface GetPickupPackagePdfRequest {
    shipmentId: string;
}

export interface GetPreBookingShipmentRequest {
    shipmentId: string;
}

export interface GetQuotePdfRequest {
    quoteId: string;
}

export interface GetShipmentCouponAmountRequest {
    shipmentId: string;
}

export interface GetShipmentsRequest {
    excludeCancelled?: boolean;
}

export interface GetTrackingRequest {
    shipmentId: string;
}

export interface HasPaymentMethodRequest {
    shipmentId: string;
}

export interface ListDocumentsRequest {
    shipmentId: string;
}

export interface ListShipmentInvoicesRequest {
    shipmentId: string;
}

export interface LookUpReferenceNumberRequest {
    referenceNumber: string;
    locationContext: LocationContext;
}

export interface LookupNmfcCodeForLineItemOperationRequest {
    lookupNmfcCodeForLineItemRequest?: LookupNmfcCodeForLineItemRequest;
}

export interface LookupNmfcCodeNoDimensionsOperationRequest {
    lookupNmfcCodeNoDimensionsRequest?: LookupNmfcCodeNoDimensionsRequest;
}

export interface MarkDeliveredOperationRequest {
    markDeliveredRequest?: MarkDeliveredRequest;
}

export interface MarkPickedUpOperationRequest {
    markPickedUpRequest?: MarkPickedUpRequest;
}

export interface MarkReviewingPriorToBookingShipmentRequest {
    shipmentId: string;
}

export interface PollQuotesRequest {
    shipmentId: string;
}

export interface RequestDeliveryHoursChangeOperationRequest {
    requestDeliveryHoursChangeRequest?: RequestDeliveryHoursChangeRequest;
}

export interface RequestManualQuotesOperationRequest {
    requestManualQuotesRequest?: RequestManualQuotesRequest;
}

export interface RequestPickupDateChangeOperationRequest {
    requestPickupDateChangeRequest?: RequestPickupDateChangeRequest;
}

export interface SelectQuoteOperationRequest {
    selectQuoteRequest?: SelectQuoteRequest;
}

export interface SetAddressOperationRequest {
    setAddressRequest?: SetAddressRequest;
}

export interface SetAddressAndContactOperationRequest {
    setAddressAndContactRequest?: SetAddressAndContactRequest;
}

export interface SetBrokerRequest {
    shipmentId: string;
    savedBrokerId: string;
}

export interface SetBrokerDetailsOperationRequest {
    setBrokerDetailsRequest?: SetBrokerDetailsRequest;
}

export interface SetChecklistItemOperationRequest {
    setChecklistItemRequest?: SetChecklistItemRequest;
}

export interface SetContactOperationRequest {
    setContactRequest?: SetContactRequest;
}

export interface SetEmergencyDetailsOperationRequest {
    setEmergencyDetailsRequest?: SetEmergencyDetailsRequest;
}

export interface SetProNumberOperationRequest {
    setProNumberRequest?: SetProNumberRequest;
}

export interface SetReferenceAndNotesOperationRequest {
    setReferenceAndNotesRequest?: SetReferenceAndNotesRequest;
}

export interface SetStripePaymentMethodIdRequest {
    getStartedSetStripePaymentMethodId?: GetStartedSetStripePaymentMethodId;
}

export interface StarShipmentOperationRequest {
    starShipmentRequest?: StarShipmentRequest;
}

export interface SwapTrackingIdForShipmentIdRequest {
    tId: string;
}

export interface UnflagShipmentOperationRequest {
    unflagShipmentRequest?: UnflagShipmentRequest;
}

export interface UnstarShipmentOperationRequest {
    unstarShipmentRequest?: UnstarShipmentRequest;
}

export interface UploadShipmentDocumentOperationRequest {
    uploadShipmentDocumentRequest?: UploadShipmentDocumentRequest;
}

/**
 * 
 */
export class ShipmentsApi extends runtime.BaseAPI {

    /**
     * Add a customer-visible tracking line (and a matching ops note) to a shipment — used by the app to record checklist milestones, attributed to the acting user.
     * 
     */
    async addTrackingLineRaw(requestParameters: AddTrackingLineOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/shipments/add-tracking-line`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AddTrackingLineRequestToJSON(requestParameters['addTrackingLineRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Add a customer-visible tracking line (and a matching ops note) to a shipment — used by the app to record checklist milestones, attributed to the acting user.
     * 
     */
    async addTrackingLine(requestParameters: AddTrackingLineOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.addTrackingLineRaw(requestParameters, initOverrides);
    }

    /**
     * Actually books a shipment with the carrier
     * Book Shipment
     */
    async bookShipmentRaw(requestParameters: BookShipmentOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BookShipmentResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/shipments/book`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BookShipmentRequestToJSON(requestParameters['bookShipmentRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BookShipmentResponseFromJSON(jsonValue));
    }

    /**
     * Actually books a shipment with the carrier
     * Book Shipment
     */
    async bookShipment(requestParameters: BookShipmentOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BookShipmentResponse> {
        const response = await this.bookShipmentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     */
    async changePickupDatePreBookingRaw(requestParameters: ChangePickupDatePreBookingOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/shipments/change-pickup-date-pre-booking`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ChangePickupDatePreBookingRequestToJSON(requestParameters['changePickupDatePreBookingRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * 
     */
    async changePickupDatePreBooking(requestParameters: ChangePickupDatePreBookingOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.changePickupDatePreBookingRaw(requestParameters, initOverrides);
    }

    /**
     * 
     * 
     */
    async checkIfAddressIsResidentialRaw(requestParameters: CheckIfAddressIsResidentialOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CheckIfAddressIsResidentialResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/get-started/check-if-address-is-residential`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CheckIfAddressIsResidentialRequestToJSON(requestParameters['checkIfAddressIsResidentialRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CheckIfAddressIsResidentialResponseFromJSON(jsonValue));
    }

    /**
     * 
     * 
     */
    async checkIfAddressIsResidential(requestParameters: CheckIfAddressIsResidentialOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CheckIfAddressIsResidentialResponse> {
        const response = await this.checkIfAddressIsResidentialRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     */
    async create2Raw(requestParameters: Create2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/shipments/create`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateShipment2RequestToJSON(requestParameters['createShipment2Request']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * 
     */
    async create2(requestParameters: Create2Request = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.create2Raw(requestParameters, initOverrides);
    }

    /**
     * Delete Quoted Shipment
     */
    async deleteQuotedShipmentRaw(requestParameters: DeleteQuotedShipmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['shipmentId'] == null) {
            throw new runtime.RequiredError(
                'shipmentId',
                'Required parameter "shipmentId" was null or undefined when calling deleteQuotedShipment().'
            );
        }

        if (requestParameters['reason'] == null) {
            throw new runtime.RequiredError(
                'reason',
                'Required parameter "reason" was null or undefined when calling deleteQuotedShipment().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['shipmentId'] != null) {
            queryParameters['shipmentId'] = requestParameters['shipmentId'];
        }

        if (requestParameters['reason'] != null) {
            queryParameters['reason'] = requestParameters['reason'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/shipments/delete-quoted-shipment`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete Quoted Shipment
     */
    async deleteQuotedShipment(requestParameters: DeleteQuotedShipmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteQuotedShipmentRaw(requestParameters, initOverrides);
    }

    /**
     * Download thumbnail for a document
     */
    async downloadThumbnailRaw(requestParameters: DownloadThumbnailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DownloadThumbnailResponse>> {
        if (requestParameters['documentId'] == null) {
            throw new runtime.RequiredError(
                'documentId',
                'Required parameter "documentId" was null or undefined when calling downloadThumbnail().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['documentId'] != null) {
            queryParameters['documentId'] = requestParameters['documentId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/shipments/download-thumbnail`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DownloadThumbnailResponseFromJSON(jsonValue));
    }

    /**
     * Download thumbnail for a document
     */
    async downloadThumbnail(requestParameters: DownloadThumbnailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DownloadThumbnailResponse> {
        const response = await this.downloadThumbnailRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Flag a shipment as needing attention, in the customer\'s own words — an inbound report that shows up on the operations Flagged list. Re-flagging an already-flagged shipment replaces the message. Attributed to the acting user.
     * 
     */
    async flagShipmentRaw(requestParameters: FlagShipmentOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/shipments/flag`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FlagShipmentRequestToJSON(requestParameters['flagShipmentRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Flag a shipment as needing attention, in the customer\'s own words — an inbound report that shows up on the operations Flagged list. Re-flagging an already-flagged shipment replaces the message. Attributed to the acting user.
     * 
     */
    async flagShipment(requestParameters: FlagShipmentOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.flagShipmentRaw(requestParameters, initOverrides);
    }

    /**
     * DEPRECATED — a shipment\'s checklist progress now rides on the shipment itself (checkedChecklistKeys / skippedChecklistKeys), so nothing needs this call. It stays only for app builds already installed that still make it; those builds fall back to \"no progress\" on a 404, which would show a worked checklist as untouched. Delete it once the minimum supported app version is above the build that stopped calling it.
     * Your GET endpoint
     * @deprecated
     */
    async getChecklistRaw(requestParameters: GetChecklistRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetChecklistResponse>> {
        if (requestParameters['shipmentId'] == null) {
            throw new runtime.RequiredError(
                'shipmentId',
                'Required parameter "shipmentId" was null or undefined when calling getChecklist().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['shipmentId'] != null) {
            queryParameters['shipmentId'] = requestParameters['shipmentId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/shipments/get-checklist`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetChecklistResponseFromJSON(jsonValue));
    }

    /**
     * DEPRECATED — a shipment\'s checklist progress now rides on the shipment itself (checkedChecklistKeys / skippedChecklistKeys), so nothing needs this call. It stays only for app builds already installed that still make it; those builds fall back to \"no progress\" on a 404, which would show a worked checklist as untouched. Delete it once the minimum supported app version is above the build that stopped calling it.
     * Your GET endpoint
     * @deprecated
     */
    async getChecklist(requestParameters: GetChecklistRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetChecklistResponse> {
        const response = await this.getChecklistRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Your GET endpoint
     */
    async getDocumentPdfRaw(requestParameters: GetDocumentPdfRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PdfResponse>> {
        if (requestParameters['documentId'] == null) {
            throw new runtime.RequiredError(
                'documentId',
                'Required parameter "documentId" was null or undefined when calling getDocumentPdf().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['documentId'] != null) {
            queryParameters['documentId'] = requestParameters['documentId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/shipments/document-pdf`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PdfResponseFromJSON(jsonValue));
    }

    /**
     * Your GET endpoint
     */
    async getDocumentPdf(requestParameters: GetDocumentPdfRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PdfResponse> {
        const response = await this.getDocumentPdfRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Your GET endpoint
     */
    async getInvoicePdfRaw(requestParameters: GetInvoicePdfRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PdfResponse>> {
        if (requestParameters['key'] == null) {
            throw new runtime.RequiredError(
                'key',
                'Required parameter "key" was null or undefined when calling getInvoicePdf().'
            );
        }

        if (requestParameters['shipmentId'] == null) {
            throw new runtime.RequiredError(
                'shipmentId',
                'Required parameter "shipmentId" was null or undefined when calling getInvoicePdf().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['key'] != null) {
            queryParameters['key'] = requestParameters['key'];
        }

        if (requestParameters['shipmentId'] != null) {
            queryParameters['shipmentId'] = requestParameters['shipmentId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/shipments/invoice-pdf`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PdfResponseFromJSON(jsonValue));
    }

    /**
     * Your GET endpoint
     */
    async getInvoicePdf(requestParameters: GetInvoicePdfRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PdfResponse> {
        const response = await this.getInvoicePdfRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Download Multiple Invoices as ZIP
     */
    async getInvoicesZipRaw(requestParameters: GetInvoicesZipOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ZipResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/shipments/invoice-zip`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetInvoicesZipRequestToJSON(requestParameters['getInvoicesZipRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ZipResponseFromJSON(jsonValue));
    }

    /**
     * Download Multiple Invoices as ZIP
     */
    async getInvoicesZip(requestParameters: GetInvoicesZipOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ZipResponse> {
        const response = await this.getInvoicesZipRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * Your GET endpoint
     */
    async getOneShipmentRaw(requestParameters: GetOneShipmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetOneShipmentResponse>> {
        if (requestParameters['shipmentId'] == null) {
            throw new runtime.RequiredError(
                'shipmentId',
                'Required parameter "shipmentId" was null or undefined when calling getOneShipment().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['shipmentId'] != null) {
            queryParameters['shipmentId'] = requestParameters['shipmentId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/shipments/get-one-shipment`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetOneShipmentResponseFromJSON(jsonValue));
    }

    /**
     * 
     * Your GET endpoint
     */
    async getOneShipment(requestParameters: GetOneShipmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetOneShipmentResponse> {
        const response = await this.getOneShipmentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Your GET endpoint
     */
    async getPickupPackagePdfRaw(requestParameters: GetPickupPackagePdfRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PdfResponse>> {
        if (requestParameters['shipmentId'] == null) {
            throw new runtime.RequiredError(
                'shipmentId',
                'Required parameter "shipmentId" was null or undefined when calling getPickupPackagePdf().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['shipmentId'] != null) {
            queryParameters['shipmentId'] = requestParameters['shipmentId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/shipments/pickup-package-pdf`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PdfResponseFromJSON(jsonValue));
    }

    /**
     * Your GET endpoint
     */
    async getPickupPackagePdf(requestParameters: GetPickupPackagePdfRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PdfResponse> {
        const response = await this.getPickupPackagePdfRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Your GET endpoint
     */
    async getPreBookingShipmentRaw(requestParameters: GetPreBookingShipmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PreBookingShipment>> {
        if (requestParameters['shipmentId'] == null) {
            throw new runtime.RequiredError(
                'shipmentId',
                'Required parameter "shipmentId" was null or undefined when calling getPreBookingShipment().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['shipmentId'] != null) {
            queryParameters['shipmentId'] = requestParameters['shipmentId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/shipments/get-pre-booking-shipment`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PreBookingShipmentFromJSON(jsonValue));
    }

    /**
     * Your GET endpoint
     */
    async getPreBookingShipment(requestParameters: GetPreBookingShipmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PreBookingShipment> {
        const response = await this.getPreBookingShipmentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get quote PDF
     */
    async getQuotePdfRaw(requestParameters: GetQuotePdfRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PdfResponse>> {
        if (requestParameters['quoteId'] == null) {
            throw new runtime.RequiredError(
                'quoteId',
                'Required parameter "quoteId" was null or undefined when calling getQuotePdf().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['quoteId'] != null) {
            queryParameters['quoteId'] = requestParameters['quoteId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/shipments/quote-pdf`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PdfResponseFromJSON(jsonValue));
    }

    /**
     * Get quote PDF
     */
    async getQuotePdf(requestParameters: GetQuotePdfRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PdfResponse> {
        const response = await this.getQuotePdfRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get total coupon amount applied to a shipment
     */
    async getShipmentCouponAmountRaw(requestParameters: GetShipmentCouponAmountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetCouponResponse>> {
        if (requestParameters['shipmentId'] == null) {
            throw new runtime.RequiredError(
                'shipmentId',
                'Required parameter "shipmentId" was null or undefined when calling getShipmentCouponAmount().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['shipmentId'] != null) {
            queryParameters['shipmentId'] = requestParameters['shipmentId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/shipments/coupon-amount`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetCouponResponseFromJSON(jsonValue));
    }

    /**
     * Get total coupon amount applied to a shipment
     */
    async getShipmentCouponAmount(requestParameters: GetShipmentCouponAmountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetCouponResponse> {
        const response = await this.getShipmentCouponAmountRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Every shipment on the account. Cancelled ones are included by default because the dashboard\'s shipment list offers a Cancelled filter and reads from here; a client that only wants live work (the mobile app) passes excludeCancelled=true so they never leave the server.
     * Your GET endpoint
     */
    async getShipmentsRaw(requestParameters: GetShipmentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetShipmentsResponse>> {
        const queryParameters: any = {};

        if (requestParameters['excludeCancelled'] != null) {
            queryParameters['excludeCancelled'] = requestParameters['excludeCancelled'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/shipments/get-shipments`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetShipmentsResponseFromJSON(jsonValue));
    }

    /**
     * Every shipment on the account. Cancelled ones are included by default because the dashboard\'s shipment list offers a Cancelled filter and reads from here; a client that only wants live work (the mobile app) passes excludeCancelled=true so they never leave the server.
     * Your GET endpoint
     */
    async getShipments(requestParameters: GetShipmentsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetShipmentsResponse> {
        const response = await this.getShipmentsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Your GET endpoint
     */
    async getTrackingRaw(requestParameters: GetTrackingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TrackingInfo>> {
        if (requestParameters['shipmentId'] == null) {
            throw new runtime.RequiredError(
                'shipmentId',
                'Required parameter "shipmentId" was null or undefined when calling getTracking().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['shipmentId'] != null) {
            queryParameters['shipmentId'] = requestParameters['shipmentId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/shipments/get-tracking`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TrackingInfoFromJSON(jsonValue));
    }

    /**
     * Your GET endpoint
     */
    async getTracking(requestParameters: GetTrackingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TrackingInfo> {
        const response = await this.getTrackingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Your GET endpoint
     */
    async hasBookedOnlyOneShipmentRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<HasBookedOnlyOneShipmentResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/shipments/has-booked-only-one-shipment`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => HasBookedOnlyOneShipmentResponseFromJSON(jsonValue));
    }

    /**
     * Your GET endpoint
     */
    async hasBookedOnlyOneShipment(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<HasBookedOnlyOneShipmentResponse> {
        const response = await this.hasBookedOnlyOneShipmentRaw(initOverrides);
        return await response.value();
    }

    /**
     * Your GET endpoint
     */
    async hasPaymentMethodRaw(requestParameters: HasPaymentMethodRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<HasPaymentMethodResponse>> {
        if (requestParameters['shipmentId'] == null) {
            throw new runtime.RequiredError(
                'shipmentId',
                'Required parameter "shipmentId" was null or undefined when calling hasPaymentMethod().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['shipmentId'] != null) {
            queryParameters['shipmentId'] = requestParameters['shipmentId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/shipments/has-payment-method`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => HasPaymentMethodResponseFromJSON(jsonValue));
    }

    /**
     * Your GET endpoint
     */
    async hasPaymentMethod(requestParameters: HasPaymentMethodRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<HasPaymentMethodResponse> {
        const response = await this.hasPaymentMethodRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Your GET endpoint
     */
    async listDocumentsRaw(requestParameters: ListDocumentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListDocumentsResponse>> {
        if (requestParameters['shipmentId'] == null) {
            throw new runtime.RequiredError(
                'shipmentId',
                'Required parameter "shipmentId" was null or undefined when calling listDocuments().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['shipmentId'] != null) {
            queryParameters['shipmentId'] = requestParameters['shipmentId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/shipments/list-documents`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListDocumentsResponseFromJSON(jsonValue));
    }

    /**
     * Your GET endpoint
     */
    async listDocuments(requestParameters: ListDocumentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListDocumentsResponse> {
        const response = await this.listDocumentsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Your GET endpoint
     */
    async listShipmentInvoicesRaw(requestParameters: ListShipmentInvoicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Invoice>>> {
        if (requestParameters['shipmentId'] == null) {
            throw new runtime.RequiredError(
                'shipmentId',
                'Required parameter "shipmentId" was null or undefined when calling listShipmentInvoices().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['shipmentId'] != null) {
            queryParameters['shipmentId'] = requestParameters['shipmentId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/shipments/list-invoices`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(InvoiceFromJSON));
    }

    /**
     * Your GET endpoint
     */
    async listShipmentInvoices(requestParameters: ListShipmentInvoicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Invoice>> {
        const response = await this.listShipmentInvoicesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Looks up for previous shipments with the same reference number
     * Your GET endpoint
     */
    async lookUpReferenceNumberRaw(requestParameters: LookUpReferenceNumberRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LookUpReferenceNumberResponse>> {
        if (requestParameters['referenceNumber'] == null) {
            throw new runtime.RequiredError(
                'referenceNumber',
                'Required parameter "referenceNumber" was null or undefined when calling lookUpReferenceNumber().'
            );
        }

        if (requestParameters['locationContext'] == null) {
            throw new runtime.RequiredError(
                'locationContext',
                'Required parameter "locationContext" was null or undefined when calling lookUpReferenceNumber().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['referenceNumber'] != null) {
            queryParameters['referenceNumber'] = requestParameters['referenceNumber'];
        }

        if (requestParameters['locationContext'] != null) {
            queryParameters['locationContext'] = requestParameters['locationContext'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/shipments/look-up-reference-number`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LookUpReferenceNumberResponseFromJSON(jsonValue));
    }

    /**
     * Looks up for previous shipments with the same reference number
     * Your GET endpoint
     */
    async lookUpReferenceNumber(requestParameters: LookUpReferenceNumberRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LookUpReferenceNumberResponse> {
        const response = await this.lookUpReferenceNumberRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     */
    async lookupNmfcCodeForLineItemRaw(requestParameters: LookupNmfcCodeForLineItemOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LookupNmfcCodeForLineItemResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/shipments/lookup-nmfc-code-for-line-item`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: LookupNmfcCodeForLineItemRequestToJSON(requestParameters['lookupNmfcCodeForLineItemRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LookupNmfcCodeForLineItemResponseFromJSON(jsonValue));
    }

    /**
     * 
     */
    async lookupNmfcCodeForLineItem(requestParameters: LookupNmfcCodeForLineItemOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LookupNmfcCodeForLineItemResponse> {
        const response = await this.lookupNmfcCodeForLineItemRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     */
    async lookupNmfcCodeNoDimensionsRaw(requestParameters: LookupNmfcCodeNoDimensionsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LookupNmfcCodeNoDimensionsResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/shipments/lookup-nmfc-code-no-dimensions`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: LookupNmfcCodeNoDimensionsRequestToJSON(requestParameters['lookupNmfcCodeNoDimensionsRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LookupNmfcCodeNoDimensionsResponseFromJSON(jsonValue));
    }

    /**
     * 
     */
    async lookupNmfcCodeNoDimensions(requestParameters: LookupNmfcCodeNoDimensionsOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LookupNmfcCodeNoDimensionsResponse> {
        const response = await this.lookupNmfcCodeNoDimensionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mark a shipment as delivered — transitions it to delivered and records who did it (a note plus a tracking line).
     * 
     */
    async markDeliveredRaw(requestParameters: MarkDeliveredOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/shipments/mark-delivered`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MarkDeliveredRequestToJSON(requestParameters['markDeliveredRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Mark a shipment as delivered — transitions it to delivered and records who did it (a note plus a tracking line).
     * 
     */
    async markDelivered(requestParameters: MarkDeliveredOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.markDeliveredRaw(requestParameters, initOverrides);
    }

    /**
     * Mark a shipment as picked up — transitions it to in-transit and records who did it (a note plus a tracking line).
     * 
     */
    async markPickedUpRaw(requestParameters: MarkPickedUpOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/shipments/mark-picked-up`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MarkPickedUpRequestToJSON(requestParameters['markPickedUpRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Mark a shipment as picked up — transitions it to in-transit and records who did it (a note plus a tracking line).
     * 
     */
    async markPickedUp(requestParameters: MarkPickedUpOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.markPickedUpRaw(requestParameters, initOverrides);
    }

    /**
     * 
     */
    async markReviewingPriorToBookingShipmentRaw(requestParameters: MarkReviewingPriorToBookingShipmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['shipmentId'] == null) {
            throw new runtime.RequiredError(
                'shipmentId',
                'Required parameter "shipmentId" was null or undefined when calling markReviewingPriorToBookingShipment().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['shipmentId'] != null) {
            queryParameters['shipmentId'] = requestParameters['shipmentId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/shipments/mark-reviewing-prior-to-booking-shipment`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * 
     */
    async markReviewingPriorToBookingShipment(requestParameters: MarkReviewingPriorToBookingShipmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.markReviewingPriorToBookingShipmentRaw(requestParameters, initOverrides);
    }

    /**
     * Your GET endpoint
     */
    async pollQuotesRaw(requestParameters: PollQuotesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PollQuotesResponse>> {
        if (requestParameters['shipmentId'] == null) {
            throw new runtime.RequiredError(
                'shipmentId',
                'Required parameter "shipmentId" was null or undefined when calling pollQuotes().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['shipmentId'] != null) {
            queryParameters['shipmentId'] = requestParameters['shipmentId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/shipments/poll-quotes`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PollQuotesResponseFromJSON(jsonValue));
    }

    /**
     * Your GET endpoint
     */
    async pollQuotes(requestParameters: PollQuotesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PollQuotesResponse> {
        const response = await this.pollQuotesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     */
    async requestDeliveryHoursChangeRaw(requestParameters: RequestDeliveryHoursChangeOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RequestDeliveryHoursChangeResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/shipments/request-delivery-hours-change`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RequestDeliveryHoursChangeRequestToJSON(requestParameters['requestDeliveryHoursChangeRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RequestDeliveryHoursChangeResponseFromJSON(jsonValue));
    }

    /**
     * 
     */
    async requestDeliveryHoursChange(requestParameters: RequestDeliveryHoursChangeOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RequestDeliveryHoursChangeResponse> {
        const response = await this.requestDeliveryHoursChangeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     */
    async requestManualQuotesRaw(requestParameters: RequestManualQuotesOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/shipments/request-manual-quotes`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RequestManualQuotesRequestToJSON(requestParameters['requestManualQuotesRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * 
     */
    async requestManualQuotes(requestParameters: RequestManualQuotesOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.requestManualQuotesRaw(requestParameters, initOverrides);
    }

    /**
     * 
     */
    async requestPickupDateChangeRaw(requestParameters: RequestPickupDateChangeOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/shipments/request-pickup-date-change`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RequestPickupDateChangeRequestToJSON(requestParameters['requestPickupDateChangeRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * 
     */
    async requestPickupDateChange(requestParameters: RequestPickupDateChangeOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.requestPickupDateChangeRaw(requestParameters, initOverrides);
    }

    /**
     * 
     */
    async selectQuoteRaw(requestParameters: SelectQuoteOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/shipments/select-quote`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SelectQuoteRequestToJSON(requestParameters['selectQuoteRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * 
     */
    async selectQuote(requestParameters: SelectQuoteOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.selectQuoteRaw(requestParameters, initOverrides);
    }

    /**
     * 
     */
    async setAddressRaw(requestParameters: SetAddressOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/shipments/set-address`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SetAddressRequestToJSON(requestParameters['setAddressRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * 
     */
    async setAddress(requestParameters: SetAddressOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.setAddressRaw(requestParameters, initOverrides);
    }

    /**
     * 
     * 
     */
    async setAddressAndContactRaw(requestParameters: SetAddressAndContactOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/get-started/set-address-and-contact`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SetAddressAndContactRequestToJSON(requestParameters['setAddressAndContactRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * 
     * 
     */
    async setAddressAndContact(requestParameters: SetAddressAndContactOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.setAddressAndContactRaw(requestParameters, initOverrides);
    }

    /**
     * 
     */
    async setBrokerRaw(requestParameters: SetBrokerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['shipmentId'] == null) {
            throw new runtime.RequiredError(
                'shipmentId',
                'Required parameter "shipmentId" was null or undefined when calling setBroker().'
            );
        }

        if (requestParameters['savedBrokerId'] == null) {
            throw new runtime.RequiredError(
                'savedBrokerId',
                'Required parameter "savedBrokerId" was null or undefined when calling setBroker().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['shipmentId'] != null) {
            queryParameters['shipmentId'] = requestParameters['shipmentId'];
        }

        if (requestParameters['savedBrokerId'] != null) {
            queryParameters['savedBrokerId'] = requestParameters['savedBrokerId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/shipments/set-broker`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * 
     */
    async setBroker(requestParameters: SetBrokerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.setBrokerRaw(requestParameters, initOverrides);
    }

    /**
     * 
     */
    async setBrokerDetailsRaw(requestParameters: SetBrokerDetailsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/get-started/set-broker-details`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SetBrokerDetailsRequestToJSON(requestParameters['setBrokerDetailsRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * 
     */
    async setBrokerDetails(requestParameters: SetBrokerDetailsOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.setBrokerDetailsRaw(requestParameters, initOverrides);
    }

    /**
     * Set a single checklist item\'s checked state (last-writer-wins).
     * 
     */
    async setChecklistItemRaw(requestParameters: SetChecklistItemOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/shipments/set-checklist-item`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SetChecklistItemRequestToJSON(requestParameters['setChecklistItemRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Set a single checklist item\'s checked state (last-writer-wins).
     * 
     */
    async setChecklistItem(requestParameters: SetChecklistItemOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.setChecklistItemRaw(requestParameters, initOverrides);
    }

    /**
     * 
     */
    async setContactRaw(requestParameters: SetContactOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/shipments/set-contact`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SetContactRequestToJSON(requestParameters['setContactRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * 
     */
    async setContact(requestParameters: SetContactOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.setContactRaw(requestParameters, initOverrides);
    }

    /**
     * 
     */
    async setEmergencyDetailsRaw(requestParameters: SetEmergencyDetailsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/get-started/set-emergency-details`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SetEmergencyDetailsRequestToJSON(requestParameters['setEmergencyDetailsRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * 
     */
    async setEmergencyDetails(requestParameters: SetEmergencyDetailsOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.setEmergencyDetailsRaw(requestParameters, initOverrides);
    }

    /**
     * Set or correct a shipment\'s carrier tracking (PRO) number from the app — attributed to the acting user, re-drives carrier tracking, and escalates a conflict (duplicate/invalid) to ops rather than failing the request.
     * 
     */
    async setProNumberRaw(requestParameters: SetProNumberOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/shipments/set-pro-number`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SetProNumberRequestToJSON(requestParameters['setProNumberRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Set or correct a shipment\'s carrier tracking (PRO) number from the app — attributed to the acting user, re-drives carrier tracking, and escalates a conflict (duplicate/invalid) to ops rather than failing the request.
     * 
     */
    async setProNumber(requestParameters: SetProNumberOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.setProNumberRaw(requestParameters, initOverrides);
    }

    /**
     * 
     */
    async setReferenceAndNotesRaw(requestParameters: SetReferenceAndNotesOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/shipment/set-reference-and-notes`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SetReferenceAndNotesRequestToJSON(requestParameters['setReferenceAndNotesRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * 
     */
    async setReferenceAndNotes(requestParameters: SetReferenceAndNotesOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.setReferenceAndNotesRaw(requestParameters, initOverrides);
    }

    /**
     * 
     */
    async setStripePaymentMethodIdRaw(requestParameters: SetStripePaymentMethodIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/get-started/set-stripe-payment-method-id`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetStartedSetStripePaymentMethodIdToJSON(requestParameters['getStartedSetStripePaymentMethodId']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * 
     */
    async setStripePaymentMethodId(requestParameters: SetStripePaymentMethodIdRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.setStripePaymentMethodIdRaw(requestParameters, initOverrides);
    }

    /**
     * Star a shipment for the requesting user. Idempotent.
     * 
     */
    async starShipmentRaw(requestParameters: StarShipmentOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/shipments/star`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: StarShipmentRequestToJSON(requestParameters['starShipmentRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Star a shipment for the requesting user. Idempotent.
     * 
     */
    async starShipment(requestParameters: StarShipmentOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.starShipmentRaw(requestParameters, initOverrides);
    }

    /**
     * 
     */
    async swapTrackingIdForShipmentIdRaw(requestParameters: SwapTrackingIdForShipmentIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SwapTrackingIdForShipmentIdResponse>> {
        if (requestParameters['tId'] == null) {
            throw new runtime.RequiredError(
                'tId',
                'Required parameter "tId" was null or undefined when calling swapTrackingIdForShipmentId().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['tId'] != null) {
            queryParameters['tId'] = requestParameters['tId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/shipments/swap-t-id-for-shipment-id`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SwapTrackingIdForShipmentIdResponseFromJSON(jsonValue));
    }

    /**
     * 
     */
    async swapTrackingIdForShipmentId(requestParameters: SwapTrackingIdForShipmentIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SwapTrackingIdForShipmentIdResponse> {
        const response = await this.swapTrackingIdForShipmentIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Withdraw a flag the customer raised on their own shipment (e.g. the problem resolved itself). Does not touch a flag raised by FreightSimple. A no-op if the shipment isn\'t flagged.
     * 
     */
    async unflagShipmentRaw(requestParameters: UnflagShipmentOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/shipments/unflag`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UnflagShipmentRequestToJSON(requestParameters['unflagShipmentRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Withdraw a flag the customer raised on their own shipment (e.g. the problem resolved itself). Does not touch a flag raised by FreightSimple. A no-op if the shipment isn\'t flagged.
     * 
     */
    async unflagShipment(requestParameters: UnflagShipmentOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.unflagShipmentRaw(requestParameters, initOverrides);
    }

    /**
     * Remove the requesting user\'s star from a shipment. Idempotent.
     * 
     */
    async unstarShipmentRaw(requestParameters: UnstarShipmentOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/shipments/unstar`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UnstarShipmentRequestToJSON(requestParameters['unstarShipmentRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Remove the requesting user\'s star from a shipment. Idempotent.
     * 
     */
    async unstarShipment(requestParameters: UnstarShipmentOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.unstarShipmentRaw(requestParameters, initOverrides);
    }

    /**
     * Attach a photo or document (base64-encoded) to a shipment from the app. Images are converted to a PDF server-side; the document then appears in the shipment\'s documents list.
     * 
     */
    async uploadShipmentDocumentRaw(requestParameters: UploadShipmentDocumentOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/shipments/upload-document`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UploadShipmentDocumentRequestToJSON(requestParameters['uploadShipmentDocumentRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Attach a photo or document (base64-encoded) to a shipment from the app. Images are converted to a PDF server-side; the document then appears in the shipment\'s documents list.
     * 
     */
    async uploadShipmentDocument(requestParameters: UploadShipmentDocumentOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.uploadShipmentDocumentRaw(requestParameters, initOverrides);
    }

}
